export interface CoresEspecialidade {
  primary: string;
  secondary: string;
  gradient: string;
  name: string;
  logo?: string;
  logoVertical?: string;
}

export const CORES_ESPECIALIDADES: Record<string, CoresEspecialidade> = {
  PADRAO: {
    primary: '#2e4b9d',
    secondary: '#E3E8F4',
    gradient: 'linear-gradient(135deg, #2e4b9d, #2e4b9d)',
    name: 'Padrao',
    logo: '/logo-medics-horizontal.jpg',
    logoVertical: '/logo-medics-vertical.png',
  },

  Cardiologia: {
    primary: '#ca6393',
    secondary: '#fd8d71',
    gradient: 'linear-gradient(135deg, #ca6393, #fd8d71)',
    name: 'Cardiologia',
    logo: '/logo-medics-cardiologia-horizontal.png',
    logoVertical: '/logo-medics-cardiologia-vertical.png',
  },

  Pediatria: {
    primary: '#15c4b4',
    secondary: '#52e2cf',
    gradient: 'linear-gradient(135deg, #15c4b4, #52e2cf)',
    name: 'Pediatria',
    logo: '/logo-medics-pediatria-horizontal.png',
    logoVertical: '/logo-medics-pediatria-vertical.png',
  },

  Ortopedia: {
    primary: '#4d9edc',
    secondary: '#afbbf4',
    gradient: 'linear-gradient(150deg, #4d9edc, #afbbf4)',
    name: 'Ortopedia',
    logo: '/Logo Medics Horizontal  Ortopedia branco.png',
    logoVertical: '/Logo Medics Ortopedia.png',
  },

  Neurologia: {
    primary: '#b57fd3',
    secondary: '#fba7cf',
    gradient: 'linear-gradient(135deg, #b57fd3, #fba7cf)',
    name: 'Neurologia',
    logo: '/Logo Medics Horizontal Neurologia.png',
    logoVertical: '/Logo Medics Neurologia.png',
  },

  Oftalmologia: {
    primary: '#625fff',
    secondary: '#a698ff',
    gradient: 'linear-gradient(135deg, #625fff, #a698ff)',
    name: 'Oftalmologia',
    logo: '/Logo Medics Horizontal  Oftamologia branco.png',
    logoVertical: '/Logo Medics Oftamologia.png',
  },

  ClinicoGeral: {
    primary: '#3974b5',
    secondary: '#2e4b9d',
    gradient: 'linear-gradient(135deg, #3974b5, #2e4b9d)',
    name: 'Clinico Geral',
    logo: '/Logo Medics Horizontal Clínica Geral branco.png',
    logoVertical: '/Logo Medics Clínica Geral.png',
  },

  Geriatria: {
    primary: '#54ddac',
    secondary: '#17bf7b',
    gradient: 'linear-gradient(135deg, #54ddac, #17bf7b)',
    name: 'Geriatria',
    logo: '/Logo Medics Horizontal Geriatria branco.png',
    logoVertical: '/Logo Medics Geriatria.png',
  },

  Gastroenterologia: {
    primary: '#fd8d71',
    secondary: '#dd5e45',
    gradient: 'linear-gradient(135deg, #fd8d71, #dd5e45)',
    name: 'Gastroenterologia',
    logo: '/Logo Medics Horizontal Gastro branco.png',
    logoVertical: '/Logo Medics Gastro.png',
  },

  Endocrinologia: {
    primary: '#ba568b',
    secondary: '#680011',
    gradient: 'linear-gradient(150deg, #ba568b, #680011)',
    name: 'Endocrinologia',
    logo: '/Logo Medics Horizontal Endocrino branco.png',
    logoVertical: '/Logo Medics Endocrino.png',
  },

  Angiologia: {
    primary: '#b71c1c',
    secondary: '#d64550',
    gradient: 'linear-gradient(135deg, #b71c1c, #d64550)',
    name: 'Angiologia',
    logo: '/Logo Medics Horizontal Angiologia branco.png',
    logoVertical: '/Logo Medics Angiologia.png',
  },

  Dermatologia: {
    primary: '#ffc57b',
    secondary: '#ff8c42',
    gradient: 'linear-gradient(135deg, #ffc57b, #ff8c42)',
    name: 'Dermatologia',
    logo: '/Logo Medics Horizontal Dermato.png',
    logoVertical: '/Logo Medics Dermatologia.png',
  },

  GinecologiaeObstetrícia: {
    primary: '#fba7cf',
    secondary: '#ba568b',
    gradient: 'linear-gradient(50deg, #fba7cf, #ba568b)',
    name: 'Ginecologia e Obstetrícia',
    logo: '/Logo Medics Horizontal Gineco e Obstetra Branco.png',
    logoVertical: '/Logo Medics Ginecologia e Obstetrícia.png',
  },

  Hematologia: {
    primary: '#dc133b',
    secondary: '#8b0000',
    gradient: 'linear-gradient(135deg, #dc133b, #8b0000)',
    name: 'Hematologia',
    logo: '/Logo Medics Horizontal Hematologia branco.png',
    logoVertical: '/Logo Medics Hematologia.png',
  },

  Homeopatia: {
    primary: '#c7e261',
    secondary: '#9dbf1f',
    gradient: 'linear-gradient(135deg, #c7e261, #9dbf1f)',
    name: 'Homeopatia',
    logo: '/Logo Medics Horizontal Homeopatia branco.png',
    logoVertical: '/Logo Medics Homeopatia.png',
  },

  Infectologia: {
    primary: '#54dddd',
    secondary: '#178bbf',
    gradient: 'linear-gradient(135deg, #54dddd, #178bbf)',
    name: 'Infectologia',
    logo: '/Logo Medics Horizontal Infectologia branco.png',
    logoVertical: '/Logo Medics Infectologia.png',
  },

  Nefrologia: {
    primary: '#feb70d',
    secondary: '#fe9d10',
    gradient: 'linear-gradient(135deg, #feb70d, #fe9d10)',
    name: 'Nefrologia',
    logo: '/Logo Medics Horizontal Nefrologia branco.png',
    logoVertical: '/Logo Medics Nefrologia.png',
  },

  Otorrinolaringologia: {
    primary: '#00ca80',
    secondary: '#007c73',
    gradient: 'linear-gradient(135deg, #00ca80, #007c73)',
    name: 'Otorrinolaringologia',
    logo: '/Logo Medics Horizontal Otorrino branco.png',
    logoVertical: '/Logo Medics Otorrinolaringologia.png',
  },

  Pneumologia: {
    primary: '#2c9199',
    secondary: '#013b45',
    gradient: 'linear-gradient(150deg, #2c9199, #013b45)',
    name: 'Pneumologia',
    logo: '/Logo Medics Horizontal Pneumo branco.png',
    logoVertical: '/Logo Medics Pneumologia.png',
  },

  Proctologia: {
    primary: '#2c99f2',
    secondary: '#166ba5',
    gradient: 'linear-gradient(150deg, #2c99f2, #166ba5)',
    name: 'Proctologia',
    logo: '/Logo Medics Horizontal Procto branco.png',
    logoVertical: '/Logo Medics Proctologia.png',
  },

  Psiquiatria: {
    primary: '#a950ff',
    secondary: '#5916c1',
    gradient: 'linear-gradient(135deg, #a950ff, #5916c1)',
    name: 'Psiquiatria',
    logo: '/Logo Medics Horizontal Psiquiatria branco.png',
    logoVertical: '/Logo Medics Psiquiatria.png',
  },

  Reumatologia: {
    primary: '#fb8b25',
    secondary: '#e36415',
    gradient: 'linear-gradient(135deg, #fb8b25, #e36415)',
    name: 'Reumatologia',
    logo: '/Logo Medics Horizontal Reumatologia branco.png',
    logoVertical: '/Logo Medics Reumatologia.png',
  },

  Urologia: {
    primary: '#849b48',
    secondary: '#59662f',
    gradient: 'linear-gradient(135deg, #849b48, #59662f)',
    name: 'Urologia',
    logo: '/Logo Medics Horizontal Urologia branco.png',
    logoVertical: '/Logo Medics Urologia.png',
  },


};

export function getCoresPorEspecialidade(especialidade?: string): CoresEspecialidade {
  if (!especialidade) {
    return CORES_ESPECIALIDADES.PADRAO;
  }

  return CORES_ESPECIALIDADES[especialidade] || CORES_ESPECIALIDADES.PADRAO;
}
